import { ellipsis } from "polished";
import styled, { css } from "styled-components";

const breakpoints = {
  small: "576px",
  medium: "767px",
  large: "992px",
  xlarge: "1200px",
};


const media = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpoints[label]}) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});


export const Body = styled.div`
  width: 100%;
  background-color: #ffff;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  overflow-y: hidden;
  ${media.medium`
  width: 100%;
  padding-left: 10px;
  `}
`;

export const ImageContainber = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SchoolImage = styled.img`
  width: 100%;
  position: relative;
  border-top-right-radius: 5%;
  border-bottom-right-radius: 5%;
`;
export const DefaultImg = styled.div`
  background-color: #2555ef;
  width: 100%;
  height: 100%;
  border-top-right-radius: 5%;
  border-bottom-right-radius: 13%;
  svg {
    padding-left: 20%;
    margin-left: 4%;
    fill: #2555ef;
    filter: drop-shadow(7px 4px 78px rgba(44, 52, 104, 0.16));
    border-bottom-right-radius: 5%;
  }
`;
export const LogoImage = styled.img`
  position: absolute;
  top: 32px;
  left: 53px;
  z-index: 5;
  width: 10%;
  background-color: #ffff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);

`;
export const Content = styled.div`
  position: absolute;
  top: 75%;
  left: 4%;
  width: fit-content;
  line-break: auto;
`;
export const Title = styled.h1`
  font-style: normal;
  font-weight: var(--general-display-font-weight);
  font-size: var(--general-display-font-size);
  line-height: 39px;
  color: var(--font-color-white);
`;

export const AboutUs = styled.button`
  color: var(--font-color-blue2555ef);
  border-radius: 5px;
  background: var(--white, #fff);
  border: none;
  display: flex;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: var(--general-label-font-size);
  font-weight: var(--general-label-font-weight);
  line-height: 32px;
`;

// First Page Right Side
export const RightSideWrappr = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media only screen and (max-width: 1920px) and (max-height: 1080px) {
    margin: 31px 40px;
    margin-left: 61px;
    width: 40%;
  }
  @media only screen and (max-width: 1035px) {
    margin-left: 0;
  }
  ${media.medium`
    margin: 20px 16px;
    width: 100%;
    padding-right: 0;
  `}
  width: 45%;
  margin-top: 77px;
`;
export const RightSideContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 50px;
  height: 100%;
  ${media.medium`
    padding-right: 10px;
  `}
`;
export const LeftSideWrapper = styled.div`
  flex: 1;
  width: 60%;
  margin-right: 30px;
  ${media.medium`
    display: none;
  `}
`;

export const Spinner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const EventType = styled.div`
  width: 100%;
  height: 123px;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(37, 85, 239, 0.04);
  padding-top: 23px;
  padding-bottom: 23px;
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 16px;
`;
export const EventTypeName = styled.div`
  width: 166px;
  height: 77px;
  flex-shrink: 0;
  padding-left: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: var(--font-color-blue007bff);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: var(--general-page-header-font-family);
  font-size: var(--general-page-header-font-size);
  font-style: normal;
  font-weight: var(--general-page-header-font-weight);
  line-height: 32px; /* 123.077% */
  text-transform: capitalize;
  border-right: 1px solid rgba(0, 46, 92, 0.05);
  span {
    color: var(--font-color-blue002e5c);
    font-size: var(--general-caption-font-size);
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
  }
`;
export const EventTypeDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 40px;
  text-align: left;
  font-weight: var(--general-body-font-weight);
  font-size: var(--general-body-font-size);

  div {
    flex-direction: row;
  }
  span {
    color: var(--font-color-blue002e5c);
    font-family: var(--general-caption-font-family);
    font-size: var(--general-caption-font-size);
    font-style: normal;
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
    text-transform: capitalize;
    opacity: 0.7;
  }
`;

export const FormTitle = styled.div`
  text-align: center;
`;
export const FormName = styled.h1`
  font-style: normal;
  font-weight: var(--general-page-header-font-weight);
  font-size: var(--general-page-header-font-size);
  line-height: 29px;
  color: var(--font-color-blue002e5c);
`;

export const FormCaption = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: var(--general-large-body-font-family);
  font-style: normal;
  font-weight: var(--general-large-body-font-weight);
  font-size: var(--general-large-body-font-size);
  /* line-height: 40px; */
  text-transform: capitalize;
  color: var(--font-color-blue002e5c);
  @media only screen and (max-width: 1035px) {
    flex-direction: column;
    align-items: center;
  }
  div {
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 3px 10px;
    gap: 10px;
    font-size: var(--general-small-label-font-size);
    font-weight: var(--font-weight-bold);
    background: rgba(250, 51, 114, 0.2);
    border-radius: 5px;
    margin-left: 8px;
    color: var(--font-color-redfa3372);
    @media only screen and (max-width: 1035px) {
      margin-left: 0;
      margin-top: 6px;
    }
  }
`;
export const Description = styled.div`
  span {
    color: var(--font-color-blue002e5c);
    opacity: 0.7;
    font-size: var(--general-caption-font-size);
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
  }
  p {
    color: var(--font-color-blue002e5c);
    font-size: var(--general-large-body-font-size);
    font-weight: var(--general-large-body-font-weight);
    line-height:normal;
    font-feature-settings: "clig" off, "liga" off;
    font-family: var(--general-large-body-font-family);
  }
`;
export const DescriptionText = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  font-size: var(--general-small-header-font-size);
  font-weight: var(--general-small-header-font-weight);
  margin-top: 13px;
  ${({ showMore }) => showMore && ellipsis(undefined, 3)}
`;

export const ShowMoreText = styled.div`
  cursor: pointer;
  font-size: var(--general-small-header-font-size);
  /* margin-top: 20px; */
  margin-bottom: 30px;
  font-weight: var(--general-small-header-font-weight);
`;
export const ContactTitle = styled.div`
  font-size: var(--general-small-label-font-size);
  opacity: 0.7;
  color: var(--font-color-blue002e5c);
  padding-bottom: 5px;
`;
export const ContactInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-weight: var(--general-body-font-weight);
  font-size: var(--general-body-font-size);
  margin-bottom: 20px;

  span {
    color: var(--font-color-blue002e5c);
    font-family: var(--general-caption-font-family);
    font-size: var(--general-caption-font-size);
    font-style: normal;
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
    text-transform: capitalize;
    opacity: 0.7;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  width: 100px;
`;
export const DashLine = styled.hr`
  border-top: dashed 2px #002e5c;
  opacity: 0.2;
  width: 100%;
`;
export const PayDetails = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  color: var(--font-color-blue002e5c);

  li {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: var(--general-body-font-weight);
    font-size: var(--general-body-font-size);
    line-height: 21px;
  }
  span {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: var(--general-body-font-weight);
    font-size: var(--general-body-font-size);
    line-height: 21px;
    span {
      color: var(--font-color-blue002e5c);
      text-align: right;
      font-family: var(--general-small-header-font-family);
      font-size: var(--general-small-header-font-size);
      font-style: normal;
      font-weight: var(--general-small-header-font-weight);
      line-height: normal;
      text-transform: capitalize;
    }
  }
`;
export const TotalPay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: var(--font-weight-regular);
  font-size: var(--general-amount-font-size);
  line-height: 21px;
  span {
    color: var(--font-color-blue002e5c);
    text-align: right;
    font-weight: var(--font-weight-bold);
    line-height: normal;
    text-transform: capitalize;
  }
`;
export const CounterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;
export const CounterDetails = styled.div`
  

`
export const ReserveAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 50px;
  padding-top: 10px;
  gap: 15px;
  ${media.medium`
      margin-right: 10px;
  `}

  @media only screen and (max-width: 420px) {
    flex-direction: column;
  }
`;

export const FormLogin = styled.div`
 display: flex;
 justify-content: flex-end;
`;

export const ReserveLoginButton = styled.button`
  background: transparent !important;
  color: var(--font-color-blue2555ef);
  border: none;
  font-weight: var(--general-button-font-weight);
  font-size: var(--general-button-font-size);
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
`;
export const ReserveButton = styled.button`
  display: flex;
  height: 48px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background:${(props) => (props.disabledButton ? '#F0F0F3' : '#2555EF')};
  color: ${(props) => (props.disabledButton ? '#B5B5C3' : 'var(--White-100, #fff)')};
  cursor: ${(props) => (props.disabledButton ? 'not-allowed !important' : 'pointer')};
  font-feature-settings: "clig" off, "liga" off;
  /* Small Medium 13 */
  font-family: var(--general-button-font-family);
  font-size: var(--general-button-font-size);
  font-style: normal;
  font-weight: var(--general-button-font-weight);
  line-height: 32px; /* 246.154% */
  text-transform: capitalize;
  border: 0;
  /* margin-top: 5%; */
  ${media.medium`
  height: 42px;

  `
}

  @media only screen and (max-width: 420px) {
    width: 100%;
  }
`;

export const Note = styled.div`
      opacity: 0.7;
    color: var(--font-color-blue002e5c);

`
export const ContactInfoDetails =styled.div`
     display: flex;
    align-items: baseline;
    flex-direction: row;
    width: 71%;
    ${media.medium`
    flex-direction:column ;
    `}


`